import axios from "axios";
import { SET_LOGIN_ERROR, SET_CURRENT_USER, CLEAR_STATE, GET_ERRORS, SET_REGISTERED_USER, GET_CUSTOMER_PROFILE, UPDATE_CUSTOMER_PROFILE, FETCH_ALL_BUSINESS_LOCATIONS, SET_LOCATION_LABEL } from "./types";
import setAuthToken from "../utils/setAuthToken";
import { setLoading } from "./commonActions";
import { getError } from "./errorActions";
const authURL = process.env.REACT_APP_API_AUTH_URL;
const client_id = process.env.REACT_APP_OAUTH_CLIENT_ID;
const secret = process.env.REACT_APP_OAUTH_SECRET_KEY;

const encoded = btoa(client_id + ":" + secret);

const refreshTokenData = {
  grant_type: "refresh_token",
  refresh_token:
    localStorage.headers &&
    JSON.parse(localStorage.getItem("headers")).data?.token,
};
//Login User
export const loginUser = (userData, shouldRefresh, isRegister) => (dispatch) => {
  userData.business_id = userData?.business_id || localStorage.getItem("business_id");

  // console.log(authURL);

  dispatch(setLoading());
  axios
    .post(
      authURL,
      userData === null && shouldRefresh ? refreshTokenData : userData,
      // userData,
      {
        headers: {
          Authorization: `Basic ${encoded}`,
        },
      }
    )
    .then((res) => {
      var data = res.data;
      if (data.message && data.message === "Please enter correct password") {
        dispatch({ type: SET_LOGIN_ERROR, payload: data.message });
        return;
      }
      data.is_email_verified = 1
      data.is_phone_verified = 1
      if (res?.status) {
        var d = new Date();
        var n = d.getTime();
        data["created_at"] = n;

        // var userData = {
        //   id: data.data.id,
        //   username: data.data.username,
        //   email: data.data.email,
        //   fname: data.data.first_name,
        //   lname: data.data.last_name,
        //   surname: data.data.surname,
        //   dob: data.data.dob,
        //   gender: data.data.gender,
        //   contact_id: data.data.contact_id,
        //   contactNo: data.data.contact_number,
        //   address: data.data.address_line_1,
        //   city: data.data.city,
        //   zip: data.data.zip_code,
        //   country: data.data.country
        // }

        var userData = {
          id: data.id,
          username: data.username,
          email: data.email,
          fname: data.first_name,
          lname: data.last_name,
          surname: data.surname,
          dob: data.dob,
          gender: data.gender,
          contact_id: data.contact_id,
          contactNo: data.contact_number,
          address: data.address_line_1,
          city: data.city,
          zip: data.zip_code,
          country: data.country,
          user_id: data.user_id
        }

        var returnData = {
          data: {
            user: userData,
            token: data.access_token,
            token_expired_at: data.expires_at,
          }
        }

        localStorage.setItem("headers", JSON.stringify(returnData));
        // Mark that the user is logged in (used by header to show correct UI)
        // try {
        //   localStorage.setItem("login", true);
        // } catch (e) {
        //   console.warn('Unable to set localStorage login flag', e);
        // }
        setAuthToken(`Bearer ${data.access_token}`);
        returnData.data.is_register = isRegister ? true : false;
        dispatch(setCurrentUser(returnData));
      }
    })
    .catch((err) => {
      // console.log(err.response);
      let error;
      if (err.response && err.response.data) {
        error = err.response.data.message;
      } else {
        error = null;
      }
      dispatch(setCurrentUser({}));
      // console.log(error);

      // dispatch(sendError(error));
    });

  if (userData === null && shouldRefresh) {
    window.location.reload();
  }
};

export const setCurrentUser = (user) => {
  return {
    type: SET_CURRENT_USER,
    payload: user,
    loading: false
  };
};

//Log user out
export const logoutUser = () => (dispatch) => {
  axios
    .get('/auth/customer_logout')
    .then((res) => {
      console.log(res);
    })
    .catch((err) => {
      dispatch(sendError(err))
    });

  // Set current user to {} which will set isAuthenticated to false
  dispatch(setLoading());

  const business_id =localStorage.getItem("business_id");
  const location_id =localStorage.getItem("location_id");

  Object.keys(localStorage).forEach((key) => {
    if (key !== "business_id" && key !== "location_id") {
      localStorage.removeItem(key);
    }
  });
  setAuthToken(false);
  dispatch(setCurrentUser({}));

  window.location.href = `/?business_id=${business_id}&location_id=${location_id}`;
};

//Get customer change profile

export const getCustomerProfile = () => (dispatch) => {
  dispatch(setLoading())

  // console.log("HUHDUDGUG");

  axios.get("/auth/customer_profile",
  ).then((response) => {
    console.log("Status: Success!!");

    dispatch({
      type: GET_CUSTOMER_PROFILE,
      payload: response.data,
      loading: false,
    })

  }
  ).catch((err) => {
    // console.log(err);
    dispatch(sendError(err))
  })
}

export const updateCustomerProfile = (data) => (dispatch) => {
  dispatch(setLoading());


  axios.post('/auth/update_customer_profile', data)
    .then(response => {

      dispatch({
        type: UPDATE_CUSTOMER_PROFILE,
        payload: response.data,
        loading: false,
      })

    }).catch(error => {
      dispatch(sendError(error));
    });

}


export const sendError = (error) => {
  return {
    type: GET_ERRORS,
    payload: error,
  };
};

export const ClearState = () => dispatch => {
  dispatch({
    type: CLEAR_STATE
  })
};

export const checkContactNo = (data) => (dispatch) => {
  dispatch(setLoading());
  axios
    .post("validateContactNo", { "contact_number": data.contact_number, "business_id": data.business_id, "location_id": data.location_id })
    .then((res) => {
      let isRegistered = false;
      let email = '';
      let username = '';
      let is_new_user = 0;

      if (res?.data?.message === 'false') {
        isRegistered = true;
        username = res?.data?.username;
        email = res?.data.email;
      }

      dispatch({
        type: SET_REGISTERED_USER,
        isRegistered: isRegistered,
        contact_number: data.contact_number,
        country_code_value: data.country_code_value,
        partial_number: data.partial_number,
        country_code: data.country_code,
        email: email,
        username: username,
        loading: false,
        is_new_user: res?.data?.is_new_user
      });
    })

    .catch((err) => dispatch(sendError(err)));
}

export const setLoginErrorMessage = (data) => (dispatch) => {
  dispatch({
    type: SET_LOGIN_ERROR,
    payload: data
  })
}

export const businessLocations = (business_id) => (dispatch) => {
  axios.post("get_business_location_list_do", { business_id }).then((response) => {
    dispatch({
      type: FETCH_ALL_BUSINESS_LOCATIONS,
      payload: response.data
    })
  }).catch((err) => {
    console.log(err, 'err')
  });
}

export const locationLabel = (business_id, location_id) => async (dispatch) => {
  try {
    const response = await axios.post("get_business_location_list_do", { business_id });
    const locations = Array.isArray(response?.data) ? response?.data : [];

    if (locations.length === 0) return;
    const locId = location_id ? Number(location_id) : null;
    const selectedData = locations.find((item) => item.id === locId) || locations[0];

    dispatch({
      type: SET_LOCATION_LABEL,
      payload: selectedData,
    });
  } catch (err) {
    console.error("Error fetching business location list:", err);
  }
};
